import { Component, OnInit } from '@angular/core';
import { ScriptsModule } from '../../modules/scripts.module';
import { CurrencyService } from '../../services/currency.service';
import { CotizadorService } from '../../services/general/cotizador.service';
import { CompararService } from '../../services/general/comparar.service';
import { PagerService } from '../../services/extra/pager.service';
import { LoggerService } from '../../services/extra/logger.service';

import { Cotizacion }    from '../../obj/cotizacion';
import { ResCotizacion }    from '../../obj/resCotizacion';
import { ActivatedRoute, Router } from '@angular/router';

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-comparar',
  templateUrl: './comparar.component.html',
  styleUrls: ['./comparar.component.css'],
  providers: [CotizadorService,PagerService, CompararService, LoggerService]
})
export class CompararComponent implements OnInit {
    public resCotizacion;
    public modelCotizacion;
    public polizasComparar;
    public beneficiosComparar;
    public conversionMoneda;
    public idCotizacion;
    public tipoCotizacion;
    public compararCotizacion;
    public multiviajes;

    // pager object
    pager: any = {};

    // paged items
    pagedItems: any[];


  constructor( public _currencyService:CurrencyService,private route: ActivatedRoute,private router: Router,private cs:CotizadorService,private pagerService: PagerService, private compararService : CompararService, private logger: LoggerService) { }

    ngOnInit() {
      this.modelCotizacion= new Cotizacion(48,1,11,'','','',1,'','','','','','','','','','',false);
      let scripts = new ScriptsModule;
      scripts.loadScript('assets/js/msi_fss.js');

      this.route.params.subscribe(params => {
          this.idCotizacion = params['id'];
          this.tipoCotizacion = params['tipo'];
      });

      let permitidos = [2, 3, 4, 5];

      if(permitidos.includes(+this.tipoCotizacion)) {
        this.compararCotizacion=false;

          $('#divCargador').show();
          this.compararService.getComparar(this.idCotizacion, this.tipoCotizacion).subscribe( data => {
              let registro = data.json();
              var edad = registro.edades.replace(/,/g, ' ');
              const edades = edad.split(' ').map((a, index) => { return { Edad: a, Gender: 0, Posicion: (index + 1)}})
              let cotizacion = {
                  "codigo" : registro.codigo,
                  "adicional" : registro.adicional,
                  "origen" : registro.origen,
                  "destino": registro.destino,
                  "tipo": registro.tipo,
                  "inicio": registro.inicio,
                  "fin": registro.fin,
                  "dias":registro.dias,
                  "email": registro.correo,
                  "estadia": registro.estadia,
                  "e1": registro.e1 != null ? registro.e1 : registro.edades,
                  "e2": registro.e2 != null ? registro.e2 : "",
                  "e3": registro.e3 != null ? registro.e3 : "",
                  "e4": registro.e4 != null ? registro.e4 : "",
                  "e5": registro.e5 != null ? registro.e5 : "",
                  "e6": registro.e6 != null ? registro.e6 : "",
                  "e7": registro.e7 != null ? registro.e7 : "",
                  "e8": registro.e8 != null ? registro.e8 : "",
                  "aseguradora": "",
                  "ordenamiento": "",
                  "terminos": true,
                  "nombreDestino": registro.nombreDestino,
                  "nombreOrigen": registro.nombreOrigen,
                  "pasajerosArray": JSON.stringify(edades),
                  "pasajerosArrayCopia": edades
              }

              this.logger.log(JSON.stringify(cotizacion));

              let aseguradoras = [];

              for(let i = 0; i < (registro.polizas).length; i++) {
                aseguradoras[i] =  {
                    'id' : registro.polizas[i]['idAseguradora'],
                    'nombre' : registro.polizas[i]['aseguradora'],
                }
              }

              let polizas = {
                  "aseguradoras": aseguradoras,
                  "dias": registro.dias,
                  "edades": registro.edades,
                  "pasajeros": registro.pasajeros,
                  "polizas": registro.polizas
              }

              this.modelCotizacion = JSON.parse(JSON.stringify(cotizacion));
              console.log(this.modelCotizacion)
              localStorage.setItem('currentCotizacion',JSON.stringify(cotizacion));

              this.consultarPolizasCrm(polizas);
              this.multiviajes=registro.tipo==14;

          });
      }else {
        var cotizacion = localStorage.getItem('currentCotizacion');
        if(cotizacion!=null) {
          this.modelCotizacion=JSON.parse(cotizacion);
          this.compararCotizacion=true;
          this.consultarPolizas();
        }
      }
    }

    consultarPolizas(){
      //Eliminar Polizas A Comparar
      localStorage.removeItem('currentPolizasComparar');
      $('#divCargador').show();
      // const modalCotizacion =JSON.stringify(this.modelCotizacion)
      console.log(this.modelCotizacion.estadia);
      let cotizacion = {
        "pasajerosArray": this.modelCotizacion.pasajerosArray || "",
        "origen": parseInt(this.modelCotizacion.origen),
        "destino": parseInt(this.modelCotizacion.destino),
        "tipo": parseInt(this.modelCotizacion.tipo),
        "inicio": this.modelCotizacion.inicio || "",
        "fin": this.modelCotizacion.fin || "",
        "email": this.modelCotizacion.email || "",
        "estadia": this.modelCotizacion.estadia,
        "e1": this.modelCotizacion.e1 || "",
        "e2": this.modelCotizacion.e2 || "",
        "e3": this.modelCotizacion.e3 || "",
        "e4": this.modelCotizacion.e4 || "",
        "e5": this.modelCotizacion.e5 || "",
        "e6": this.modelCotizacion.e6 || "",
        "e7": this.modelCotizacion.e7 || "",
        "e8": this.modelCotizacion.e8 || "",
        "aseguradora": "",
        "ordenamiento": this.modelCotizacion.ordenamiento || "",
        "terminos": true,
        "nombreOrigen": this.modelCotizacion.nombreOrigen || "",
        "nombreDestino": this.modelCotizacion.nombreDestino || ""
      }
      this.cs.getResCotizacion(JSON.stringify(cotizacion)).then(resc => {
        this.resCotizacion= resc;
        if (cotizacion.origen == 69) {
          this.resCotizacion.polizas = this.resCotizacion.polizas.filter(item => item.aseguradora !== "QUALITAS ASSISTANCE");
        }
        this.setPage(1);
        //this.conversionMonedas(0, 'USD');
        $('#divCargador').hide();
      });
    }

    consultarPolizasCrm(polizas){
      //Eliminar Polizas A Comparar
      localStorage.removeItem('currentPolizasComparar');
      this.resCotizacion= polizas;
      this.setPage(1);
      $('#divCargador').hide();
    }

    comprarComparador(event):void{
        this.comprar(event.poliza);
    }

    comprar(poliza){
      if (this.compararCotizacion){
        poliza.edades=this.resCotizacion.edades;
        localStorage.setItem('currentPoliza',JSON.stringify(poliza));
        //this.router.navigate(['/solicitar']);
        this.router.navigate(['/upgrade'], { queryParams: { IdTipo:1} });
      }
      else {
        poliza.edades=this.resCotizacion.edades;
        localStorage.setItem('currentPoliza',JSON.stringify(poliza));
        //this.router.navigate(['/solicitar']);
        this.router.navigate(['/upgrade'], { queryParams: { IdTipo:2, Id: poliza.id } });
      }
    }

    detallePoliza(poliza){
        this.polizasComparar=this.resCotizacion.polizas.filter( o => o.row === poliza.row);
        try{
          this.beneficiosComparar=this.polizasComparar[0].coberturasCompletas;
        }catch(error){
          this.beneficiosComparar=[];
        }
        $('#modalComparar').modal('show');
    }

    clausuladoPoliza(poliza){
      console.log(poliza)
        var ancho=800;
        var alto=500;
        var posicion_x;
        var posicion_y;
        posicion_x=(screen.width/2)-(ancho/2);
        posicion_y=(screen.height/2)-(alto/2);
        if (poliza.aseguradora === 'SEGUROSparaVIAJE.NET') {
          poliza.clausulado = 'assets/clausulados/Segurosviajenet.pdf'
        }
        if (poliza.aseguradora === 'ASISA') {
          poliza.clausulado = 'assets/clausulados/Asisa.pdf'
        }
        window.open(poliza.clausulado, "", "width="+ancho+",height="+alto+",menubar=0,toolbar=0,directories=0,scrollbars=no,resizable=no,left="+posicion_x+",top="+posicion_y+"");
    }

    agregarComparar(poliza){
       this.polizasComparar= this.resCotizacion.polizas.filter( o => o.comparar === true);
       try{
            this.beneficiosComparar=this.polizasComparar[0].coberturasCompletas;
       }catch(error){
            this.beneficiosComparar=[];
       }
    }

    get currentCotizacion() { return JSON.stringify(this.modelCotizacion); }
    get currentPolizas() { return JSON.stringify(this.resCotizacion.polizas[0]); }

    conversionMonedas(posicion:any, indice:String) {
      if(this.resCotizacion.polizas[posicion - 1]) {
        let coleccion = JSON.stringify(this.resCotizacion.polizas[posicion - 1].conversionMoneda);
        this.conversionMoneda = JSON.parse(coleccion);
        let item = this.conversionMoneda.filter(x => x.id == indice)[0];
        return item.valor;
      }
    }

    ngAfterViewInit() {
       //$('#divCargador').modal('hide');
    }

    setPage(page: number) {
        if (page < 1 || page > this.pager.totalPages) {
            return;
        }
        // get pager object from service
        this.pager = this.pagerService.getPager(this.resCotizacion.polizas.length, page,6);

        // get current page of items
        this.pagedItems = this.resCotizacion.polizas.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/comparar/comparar.component.ts